import { Outlet } from "react-router-dom";
import { usePermission, PermissionType, AccessDenied } from "@workspace/shared";

export interface AdminPrivateRouteProps {
  permission: PermissionType;
}

export const AdminPrivateRoute = ({ permission }: AdminPrivateRouteProps) => {
  const { hasPermission } = usePermission();

  return hasPermission(permission) ? <Outlet /> : <AccessDenied />;
};
